// @flow

import { connect } from 'react-redux';
import { isProvisionedForBrand } from 'routes/join/utils';
import PROVISION_ENABLE from 'client/constants/enterpriseProvision';
import PrescriptionsPage from './prescriptionsPage';

const mapStateToProps: Object = (state) => {
  const { user, brand, contentfulData = {} } = state;
  const isEnterpriseProvisioned = isProvisionedForBrand(user, brand);

  return {
    contentfulData,
    isEnterpriseProvisioned,
    isLoggedIn: user.isLoggedIn,
    isProvisionEnable: PROVISION_ENABLE.PRESCRIPTIONS,
  };
};

export default connect(mapStateToProps, {})(PrescriptionsPage);
